import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { RegistrationStore } from '../../../guards/registration-store';

@Component({
  selector: 'app-payment-pending',
  imports: [],
  templateUrl: './payment-pending.component.html',
  styleUrl: './payment-pending.component.scss'
})
export class PaymentPendingComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  event = this.route.parent!.snapshot.data['event'];
  private readonly registrationStore = inject(RegistrationStore);
  contactEmail: string = environment.contact_email;

  ngOnInit() {
    this.registrationStore.clear();
  }

  constructor() {
  }

}
